export enum ModalTypes {
  CheckEmail = "CheckEmail",
  UnexpectedError = "UnexpectedError",
}
